import axios from 'axios'
import { get } from 'lodash'
import { errorLog, errorCreate } from './tools'
import { public_data } from '../libs/public_data'
import router from '../router/index'
import { Loading } from 'element-ui';
let loading        //定义loading变量
function startLoading() {    //使用Element loading-start 方法
    loading = Loading.service({
        lock: true,
        text: 'loading……',
        background: 'rgba(0, 0, 0, 0)'
    })
}
function endLoading() {    //使用Element loading-close 方法
    loading.close()
}
//那么 showFullScreenLoading() tryHideFullScreenLoading() 要干的事儿就是将同一时刻的请求合并。
//声明一个变量 needLoadingRequestCount，每次调用showFullScreenLoading方法 needLoadingRequestCount + 1。
//调用tryHideFullScreenLoading()方法，needLoadingRequestCount - 1。needLoadingRequestCount为 0 时，结束 loading。
let needLoadingRequestCount = 0
export function showFullScreenLoading() {
    if (needLoadingRequestCount === 0) {
        startLoading()
    }
    needLoadingRequestCount++
}

export function tryHideFullScreenLoading() {
    if (needLoadingRequestCount <= 0) return
    needLoadingRequestCount--
    if (needLoadingRequestCount === 0) {
        endLoading()
    }
}
// 创建一个请求实例
function createService() {
    const service = axios.create()
    // 请求拦截
    service.interceptors.request.use(config => config,
        error => {
            console.log(error)
            return Promise.reject(error)
        })
    // 响应拦截
    service.interceptors.response.use(
        response => {
            const dataAxios = response.data
            const { status } = dataAxios
            if (status === undefined) {
                // 
                return dataAxios
            } else {
                tryHideFullScreenLoading()
                switch (status) {
                    case 200:
                        return dataAxios.data
                        break
                    default:
                        if (dataAxios.msg == '未找到对应栏目') {
                            router.push({ name: 'Index' })
                            window.localStorage.clear()

                            return
                        }
                        errorCreate(`${dataAxios.msg}`)
                        break
                }
                // setTimeout(() => {
                //     tryHideFullScreenLoading()
                // }, 2000);

            }
        },
        error => {
            const status = get(error, 'response.status')
            switch (status) {
                case 400: error.message = '请求错误'; break
                case 401: error.message = '未授权，请登录'; break
                case 403: error.message = '拒绝访问'; break
                case 404: error.message = `请求地址出错: ${error.response.config.url}`; break
                case 408: error.message = '请求超时'; break
                case 500: error.message = '服务器内部错误'; break
                case 501: error.message = '服务未实现'; break
                case 502: error.message = '网关错误'; break
                case 503: error.message = '服务不可用'; break
                case 504: error.message = '网关超时'; break
                case 505: error.message = 'HTTP版本不受支持'; break
                default: break
            }
            errorLog(error)
            return Promise.reject(error)
        }
    )
    return service
}
// 创建请求方法
function createRequestFunction(service) {
    // console.log(process.env.VUE_APP_API,999)
    return function (config) {
        const configDefault = {
            baseURL: public_data.baseURL,
            data: {},
        }
        showFullScreenLoading()
        return service(Object.assign(configDefault, config))

    }
}
export const service = createService()
export const request = createRequestFunction(service)


// WEBPACK FOOTER //
// ./src/api/service.js